<template>
  <div class="empty-wrapper flexDirection" :style="emptyBox">
    <img class="emptyImage" :style="emptyImageStyle" src="./empty.png" alt="">
    <span class="text">{{text}}</span>
  </div>
</template>

<script>
export default {
    props:{
        text:{
            type:String,
            default:'暂无数据'
        },
        textFontSize:{
            type:String,
            default:'20'
        },
        boxHeight:{
            type:String,
            default:'0'
        },
        boxHeightType:{
            type:String,
            default:'px'
        },
        emptyImageSize:{
            type:String,
            default:'100'
        }
    },
    computed:{
        emptyImageStyle(){
            return{
                width:this.emptyImageSize  + 'px'
            }
        },
        emptyBox(){
            return{
                
                height:this.boxHeight > 0 ? this.boxHeight + this.boxHeightType : '100%',
            }
        },
    },
    data(){
        return{
        }
    }

}
</script>

<style lang="less" scoped>
.empty-wrapper{
    width:100%;
    .emptyImage{
        width:100px;
    }
    .text{
        color:#cccccc;
        margin: 10px;
    }

}

</style>